import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faHome, faThList, faUserCog, faUserShield} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from "react-router-dom";

const Navbar = () => {
    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-light">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><FontAwesomeIcon icon={faHome}/></div>
                    <span className="super-small-2">درخواست ها</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/requests-sc">
                    <div><FontAwesomeIcon icon={faThList}/></div>
                    <span className="super-small-2">درخواست خرد</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/drivers">
                    <div><FontAwesomeIcon icon={faUserShield}/></div>
                    <span className="super-small-2 ">راننده ها</span>
                </NavLink>
               {/* <NavLink className="nav-item nav-link  " to="/work-shifts">
                    <div><FontAwesomeIcon icon={faCheck}/></div>
                    <span className="super-small-2"> پروفایل</span>
                </NavLink>*/}
                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><FontAwesomeIcon icon={faUserCog}/></div>
                    <span className="super-small-2">پروفایل</span>
                </NavLink>
            </nav>
        </React.Fragment>
    );
};

export default Navbar;
